import { createFileRoute } from '@tanstack/react-router'
import { ColaboradoresAtestados } from '@/features/colaboradores-atestados'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/colaboradores-atestados/')({
  beforeLoad: async () => {
    await requireAdmin()
  },
  component: ColaboradoresAtestados,
})


